<template>
  <div
    class="list_overview_detail add_cartransform_info"
    style="width: 1600px"
    v-if="showACBI"
  >
    <div class="">
      <div class="detail_title">{{ title }}车辆信息</div>
      <div class="selfClose_btn" @click="closeInfo"></div>
    </div>
    <div class="account" style="height: auto">
      <el-form
        ref="carForm"
        :inline="true"
        :model="carInfo"
        :rules="rules"
        class="demo-form-inline secondLevel-form-inline"
      >
        <!-- <el-form-item label="进出厂时间：" class="secondLevel-label">
          <el-date-picker
            v-model="infoNamMap.registrationDate"
            type="datetime"
            style="width: 355px"
          >
          </el-date-picker>
        </el-form-item> -->
        <template v-for="(item, key) in carInfo" :key="key">
          <el-form-item
            v-if="infoNamMap[key].name == '车牌'"
            v-show="!carNum"
            class="secondLevel-label"
            :label="infoNamMap[key].name + '：'"
            :prop="key"
          >
            <el-input
              class="secondLevel-input"
              v-model="carInfo[key]"
              :placeholder="'请输入' + infoNamMap[key].name"
            ></el-input>
          </el-form-item>
          <!-- 驾照图片 -->
          <template v-else-if="infoNamMap[key].name == '驾照图片'">
            <br />
            <el-form-item
              class="secondLevel-label"
              :label="infoNamMap[key].name + '：'"
              :style="{
                width: '45%',
              }"
              :prop="key"
            >
              <el-upload
                class="driverImg"
                :ref="'upload' + key"
                v-model:file-list="dpUrl"
                list-type="picture-card"
                auto-upload="false"
                :on-preview="dpPreview"
                :on-success="unloadDPSuccess"
                :on-error="uploadError"
                :on-remove="handleRemoveDP"
                :limit="1"
                :action="cleanTransportIp + imgUrl + '?imageType=1'"
              >
                <div class="addIcon"></div>
              </el-upload>
            </el-form-item>
          </template>
          <!-- 随车清单图片 -->
          <el-form-item
            class="secondLevel-label"
            v-else-if="infoNamMap[key].name == '随车清单图片'"
            :label="infoNamMap[key].name + '：'"
            :style="{
              width: '45%',
            }"
            :prop="key"
          >
            <el-upload
              class="listImg"
              :ref="'upload' + key"
              v-model:file-list="lpUrl"
              list-type="picture-card"
              :on-preview="lpPreview"
              :on-success="uploadlLPSuccess"
              :on-error="uploadError"
              :on-remove="handleRemoveLP"
              :limit="1"
              :action="cleanTransportIp + imgUrl + '?imageType=2'"
            >
              <div class="addIcon"></div>
            </el-upload>
          </el-form-item>
          <el-form-item
            v-else
            class="secondLevel-label"
            :label="infoNamMap[key].name + '：'"
            :prop="key"
          >
            <el-input
              class="secondLevel-input"
              v-model="carInfo[key]"
              :placeholder="'请输入' + infoNamMap[key].name"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="footer">
      <a class="self_btn" @click="closeInfo()">关闭</a>
      <a class="self_btn" @click="saveInfo('carForm')">保存</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import imgBox from "./imgBox.vue";
export default {
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
    ...mapState({ cleanTransportIp: "cleanTransportIp" }),
  },
  data() {
    return {
      showACBI: "",
      carNum: "",
      title: "",
      rules: {
        numberPlate: [{ required: true, message: "车牌号不能为空" }],
        model: [{ required: true, message: "汽车型号不能为空" }],
        engineNumber: [{ required: true, message: "发动机编号不能为空" }],
        vin: [{ required: true, message: "VIN码不能为空" }],
        vehicleEmissions: [{ required: true, message: "车辆类型不能为空" }],
      },
      dpVisible: false,
      lpVisible: false,
      imgUrl: "/transport/upload/image",
      infoNamMap: {
        numberPlate: {
          name: "车牌",
        }, //  不能为空
        model: {
          name: "汽车型号",
        }, //  不能为空
        vehicleType: {
          name: "车辆类型",
        },
        engineNumber: {
          name: "发动机编号",
        }, //  不能为空
        issueDate: {
          name: "登记日期",
        },
        gatePostCode: {
          name: "门禁编码",
        },
        natureUse: {
          name: "用途",
        },
        owner: {
          name: "所属",
        },
        address: {
          name: "地址",
        },
        registrationDate: {
          name: "注册日期",
        },
        vehicleEmissions: {
          name: "排放标准",
        }, //不能为空
        vin: {
          name: "VIN",
        }, // 不能为空
        TID: {
          name: "TID",
        },
        OBD: {
          name: "OBD",
        },
        drivingLicenseImage: {
          name: "驾照图片",
        },
        onBoardList: {
          name: "随车清单图片",
        },
      },
      carInfo: {
        numberPlate: "", //  不能为空
        model: "", //  不能为空
        vehicleType: "",
        engineNumber: "", //  不能为空
        issueDate: "",
        gatePostCode: "",
        natureUse: "",
        owner: "",
        address: "",
        registrationDate: "",
        vehicleEmissions: "",
        vin: "",
        TID: "",
        OBD: "",
        drivingLicenseImage: "",
        onBoardList: "",
      },
      baseCarInfo: {
        numberPlate: "", //  不能为空
        model: "", //  不能为空
        vehicleType: "",
        engineNumber: "", //  不能为空
        issueDate: "",
        gatePostCode: "",
        natureUse: "",
        owner: "",
        address: "",
        registrationDate: "",
        vehicleEmissions: "",
        vin: "",
        TID: "",
        OBD: "",
        drivingLicenseImage: "",
        onBoardList: "",
      },
    };
  },
  methods: {
    getNum(num) {
      this.showACBI = true;
      this.carInfo = JSON.parse(JSON.stringify(this.baseCarInfo));
      this.carNum = num;
      this.title = num ? "编辑" : "新增";
      if (num) {
        this.getCarInfo(num);
      }
    },
    unloadDPSuccess(response, file, fileList) {
      this.carInfo.drivingLicenseImage = response.data.httpUrl;
      this.$message.success("上传成功！");
    },
    uploadlLPSuccess(response, file, fileList) {
      this.carInfo.onBoardList = response.data.httpUrl;
      this.$message.success("上传成功！");
    },
    uploadError(err) {
      console.log(err);
      this.$message.error("上传失败！");
    },
    handleRemoveDP() {
      this.carInfo.drivingLicenseImage = "";
      this.$message.success("删除成功！");
    },
    handleRemoveLP() {
      this.carInfo.onBoardList = "";
      this.$message.success("删除成功！");
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
    dpPreview() {
      this.picture_click(this.carInfo.drivingLicenseImage);
    },
    lpPreview() {
      this.picture_click(this.carInfo.onBoardList);
    },
    closeInfo() {
      this.showACBI = "";
    },
    async getCarInfo(num) {
      if (1) {
        let url = this.cleanTransportIp + "/transport/info";
        let res = await this.globalInstance.$apiUtils.get(url, {
          numberPlate: num,
        });
        if (res) {
          Object.keys(this.carInfo).forEach((item) => {
            this.carInfo[item] = res[item] || "";
          });
          this.lpUrl = this.carInfo.onBoardList
            ? [{ url: this.carInfo.onBoardList }]
            : [];
          this.dpUrl = this.carInfo.drivingLicenseImage
            ? [{ url: this.carInfo.drivingLicenseImage }]
            : [];
        }
      } else {
        let res = {
          gatePostCode: "HL-N01",
          vin: "LFWSRX9L3LAC21201",
          model: "解放牌CA4250P2K8T1NE6A",
          issueDate: "20200709",
          natureUse: "货运",
          engineNumber: "3120D036634",
          numberPlate: "冀A209VP",
          owner: "河北大通汽车贸易有限公司",
          address:
            "河北省石家庄市裕华区建设南大街与塔南路交叉口S0H0前程大厦1910室",
          registrationDate: "20200709",
          vehicleType: "重型燃气车-重型半挂牵引车",
          vehicleEmissions: 6,
          drivingLicenseImage: "",
          onBoardList:
            "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202108%2F22%2F20210822070705_cfd6b.thumb.1000_0.jpg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1666599554&t=ca1fd283273a8f715870be39fc48a5c9",
          createTime: null,
          registrationTime: null,
        };
        Object.keys(this.carInfo).forEach((item) => {
          this.carInfo[item] = res[item] || "";
        });
        this.lpUrl = this.carInfo.onBoardList
          ? [{ url: this.carInfo.onBoardList }]
          : [];
        this.dpUrl = this.carInfo.drivingLicenseImage
          ? [{ url: this.carInfo.drivingLicenseImage }]
          : [];
      }
    },
    saveInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let url = this.cleanTransportIp + "/transport/update";
          let res = await this.globalInstance.$apiUtils.post(url, this.carInfo);
          console.log(res);
          if (res) {
            this.$message.success(this.title + "成功!");
          } else {
            this.$message.error(this.title + "失败!");
          }
          this.closeInfo();
        } else {
          this.$message.error("请完善信息");
          return;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.list_overview_detail {
  background: #000000;
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border-radius: 2px;
  // border: 1px solid;
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  height: 900px;
  overflow: hidden;
  padding: 50px;
  padding-top: 100px;
  z-index: 23;
  .account {
    background: rgba(0, 59, 58, 0.7);
    border: 1px solid rgba(5, 255, 250, 0.99);
    .account-title {
      font-size: 24px;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      //   background: url("./img/icon.png") no-repeat left center;
      padding-left: 35px;
      margin-bottom: 20px;
    }
  }
  .detail_title {
    width: 300px;
    height: 60px;
    font-size: 26px;
    font-weight: 500;
    color: #f5a623;
    line-height: 57px;
    border-bottom: solid 2px #f5a623;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.driverImg {
  position: relative;
  width: 360px;
  height: 240px;
  overflow: hidden;

  :deep(.el-upload) {
    width: 360px;
    height: 240px;
  }
  :deep(.el-upload-list__item) {
    width: 360px;
    height: 240px;
  }
}
.listImg {
  width: 200px;
  height: 240px;
  position: absolute;
  overflow: hidden;

  :deep(.el-upload) {
    width: 200px;
    height: 240px;
  }
  :deep(.el-upload-list__item) {
    width: 200px;
    height: 240px;
  }
}
.add_cartransform_info {
  :deep(.el-upload) {
    position: absolute;
    left: 0;
    top: 0;
    background: url("../img/add.png") no-repeat center;
  }
  :deep(.el-upload-list) {
    position: absolute;
    z-index: 2;
  }
  :deep(.el-upload-list__item-actions) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :deep(.el-icon-delete) {
    transform: scale(2.5);
  }
  :deep(.el-icon-zoom-in) {
    margin-right: 30px;
    transform: scale(2.5);
  }
  :deep(.el-icon-close-tip) {
    display: none !important;
  }

  :deep(.el-form-item__error) {
    font-size: 20px;
  }
}
</style>